export const pushToDataLayer = (payload) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
  }
}
